import util from '@/assets/js/util';
import { authStore } from "@/stores/auth";
import { filterStore } from "@/stores/filter";
import qs from 'qs'
import moment from 'moment';


const auth = authStore();
const filter = filterStore();


async function doLogin(axios) {
    let dataLogin = qs.stringify({
        'username': process.env.VUE_APP_UGEMS_USERNAME,
        'password': process.env.VUE_APP_UGEMS_PASSWORD,
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'token',
        headers: {
            'accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: dataLogin
    };

    await axios.request(config)
        .then((r) => {
            auth.updateJwtUgems(r.data);
        })
        .catch((e) => {
            util.showError(e);
        });
}

async function doSearch(axiosUgems, axiosInsting, axios, filter) {
    var keyword = filter.query_string,
        area = filter.query_area,
        synonym = filter.query_synonym,
        translate = filter.query_translate,
        location = filter.query_location?.value,
        subLocation = filter.query_sublocation?.value,
        contractorName = filter.query_kontraktor?.value
    if (area == "Area") {
        area = ""
    }
    if (location == "Location" || location == undefined) {
        location = ""
    }
    if (subLocation == "Sub Location" || subLocation == undefined) {
        subLocation = ""
    }
    if (contractorName == "Kontraktor" || contractorName == undefined) {
        contractorName = ""
    }
    if (keyword?.id) {
        keyword = keyword.riwayat_pencarian
    }
    var result = {}

    let payload = {
        query_string: keyword,
        top_k: process.env.VUE_APP_UGEMS_TOP_K,
        synonym: synonym,
        translate_only: translate
        // created_at_start: startDate,
        // created_at_end: endDate
    };

    if (filter.query_period[0]) {
        var startDate = moment(filter.query_period[0]).format('YYYY-MM-DD')
        var endDate = moment(filter.query_period.at(-1)).format('YYYY-MM-DD')
        payload.created_at_start = startDate
        payload.created_at_end = endDate
    }

    if (location) {
        payload.location_name = location;
    }

    if (subLocation) {
        payload.sublocation_name = subLocation;
    }

    if (area) {
        payload.area = area;
    }

    if (contractorName) {
        payload.contractor_name = contractorName;
    }


    result = await axiosInsting.post("ugems/search_keyword", payload,
        {
            headers: {
                'Authorization-ugems': 'Bearer ' + auth.appTokenUgems,
                'Authorization-esb': auth.appToken,
            }
        }
    ).then(r => {
        return r
    }, e => {
        return e
    })
    // console.log("ugems/search_keyword >>>",result)

    // result = await axiosUgems.post("search_keyword",payload  ,
    // { headers: { 'Authorization': 'Bearer '+auth.appTokenUgems } }
    // ).then(r=>{
    //     return r
    // }, e => {
    //    return  e
    // })

    saveHistory(axiosInsting, keyword)
    return result
}

async function saveHistory(axiosInsting, keyword) {
    var resultSave = {}
    resultSave = await axiosInsting.post("search-history", {
        email: auth?.appData?.email ?? "",
        isafeno: auth?.appData?.isafe_no ?? "",
        riwayat_pencarian: keyword
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    await getHistory(axiosInsting)

    return resultSave
}

async function deleteHistory(v, axiosInsting) {
    var url = "search-history/" + v;
    var resultDelete = {}
    resultDelete = await axiosInsting.delete(url, {}).then(r => {
        util.showInfo("success delete history")
        return r.data
    }, e => {
        util.showError(e)
        return e
    })

    await getHistory(axiosInsting)

    return resultDelete
}


async function getHistory(axiosInsting) {
    var url = "search-history?page=1&total_per_page=500&isafeno=" + auth?.appData?.isafe_no + "&email=" + auth?.appData?.email;
    var result = {}
    result = await axiosInsting.get(url, {}).then(r => {
        localStorage.removeItem("searchHistory");
        return r.data
    }, e => {
        return e
    })

    if (result.data) {
        localStorage.setItem("searchHistory", JSON.stringify(result.data));
    }

    return result
}

async function getDetail(axios, id) {
    var url = "insting/penindak-lanjut?id=" + id;
    var result = {}
    result = await axios.get(url, {}).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}

async function getConfig(axiosInsting) {
    var url = "config?page=1&total_per_page=500";
    var result = {}
    result = await axiosInsting.get(url, {}).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result.data
}

async function doSearchESB(axios, page, size, status, keyword, location, query) {
    var url = "insting/list-data?page=" + page + "&total_per_page=" + size + "&status=" + status + "&location=" + location + "&keyword=" + keyword + query
    var result = {}
    result = await axios.get(url, {},
    ).then(r => {
        return r
    }, e => {
        return e
    })

    return result
}

async function submitStatus(axios, id, status, notes, location, keyword) {
    var result = {}
    result = await axios.post("insting/validation", {
        hazard_ids: id,
        status: status,
        notes: notes,
        location: location,
        keyword: keyword,
        isafe_no: (auth.appData.isafe_no != undefined) ? auth.appData.isafe_no : ""
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}


async function confirmStatus(axios, id, status, notes, location, keyword) {
    var result = {}
    result = await axios.post("insting/confirm", {
        hazard_ids: id,
        status: status,
        notes: notes,
        location: location,
        keyword: keyword,
        isafe_no: (auth.appData.isafe_no != undefined) ? auth.appData.isafe_no : ""
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}

async function deleteStatus(axios, id, notes, location, keyword) {
    var result = {}
    result = await axios.post("insting/delete", {
        hazard_ids: id,
        notes: notes,
        location: location,
        keyword: keyword,
        isafe_no: (auth.appData.isafe_no != undefined) ? auth.appData.isafe_no : ""
    }
    ).then(r => {
        return r.data
    }, e => {
        return e
    })

    return result
}



async function getArea(axios) {
    var result = {}
    result = await axios.get("insting/get-area", {}).then(r => {
        return r.data
    }, e => {
        return e
    })

    filter.list_area = result.data;
    filter.set(filter)

    return result
}

async function getLocation(axios) {
    var location = {}
    location = await axios.get("external/location", {}).then(r => {
        return r.data
    }, e => {
        return e
    })
    var result = location.dataLocation.map(function (item) {
        var loc = {
            lokasi_id: item.id,
            value: item.location_name,
            title: item.location_name
        }
        return loc;
    });

    filter.list_location = result;
    filter.set(filter)

    return result
}

async function getSubLocation(axios, id) {
    var subLocation = {}
    subLocation = await axios.get("external/sub-location?id_location=" + id, {}).then(r => {
        return r.data
    }, e => {
        return e
    })
    let filteredSubLocation = subLocation.dataSubLocation
    var result = filteredSubLocation.map(function (item) {
        var loc = {
            value: item.name,
            title: item.name
        }
        return loc;
    });

    filter.list_sublocation = result;
    filter.set(filter)
    return result
}

async function getKontraktor(axios) {
    const filter = filterStore();
    var result = {}
    // filter.set(filter)
    // {{host_insting}}/api/esb/external/kontraktor
    result = await axios.get("external/kontraktor", {}).then(r => {
        return r.data
    }, e => {
        return e
    })

    var list = result.data.map(function (item) {
        var res = {
            id: item.id,
            value: item.name,
            title: item.name
        }
        return res;
    });

    filter.list_kontraktor = list;
    filter.set(filter)

    return result
}

export default {
    doSearch,
    doLogin,
    getDetail,
    getArea,
    getLocation,
    getSubLocation,
    getKontraktor,
    saveHistory,
    getConfig,
    getHistory,
    deleteHistory,
    doSearchESB,
    submitStatus,
    deleteStatus,
    confirmStatus
}